import { useCallback } from "react";

import useIntelligenceSettings from "shared/Intelligence/useIntelligenceSettings";
import { Action } from "types/generated";
import { AccessResult, checkAllowedAction } from "utils/access";

import { AiIntegrationView } from "../useSearchAiIntegrations/gql";

const useCanToggleAiIntegration = (): ((integration: AiIntegrationView) => AccessResult) => {
  const { canUseAiFeatures } = useIntelligenceSettings();

  return useCallback(
    (integration: AiIntegrationView) => {
      const access = checkAllowedAction(integration, Action.AiIntegrationToggle);

      if (
        access.result &&
        integration.isSpaceliftProvided &&
        !integration.enabled &&
        !canUseAiFeatures
      ) {
        return {
          result: false,
          message:
            "Turn on AI features and accept the latest terms in the organization settings first",
        };
      }

      return access;
    },
    [canUseAiFeatures]
  );
};

export default useCanToggleAiIntegration;
